import React from "react";
import { useDispatch } from "react-redux";
import { addOrUpdateTopSchemas, getSearchValue, getTopSchemas, setCountOfSchemas, setIsLoadingTopSchemas } from "../reducers/data/dataReducer";
import { useSelector } from "react-redux";
import { SchemaProviderInstance } from "../@shared/services/SchemaProvider";
import { onThrowAlert } from "../sagas/dataSaga/dataSagaActions";
import { NotificationModel } from "../reducers/main/mainModel";

export type UseLeftPanelResult = {
    onLoadWithCleaning: () => void;
    onLoadSchemas: () => void;
}

export const useLeftPanel = () => {
    const dispatch = useDispatch();
    const schemas = useSelector(getTopSchemas);
    const searchValue = useSelector(getSearchValue);

    const baseCount = 5;

    const onLoadSchemas = React.useCallback(async () => {
        dispatch(setIsLoadingTopSchemas(true));
        const schemasCount = (schemas?.length ?? 0) + baseCount;
        const result = await SchemaProviderInstance.getAll(0, schemasCount, searchValue);
        if (result.status !== 200) {
            dispatch(onThrowAlert({
                message: result.data.toString(),
                lifeTime: 10000
            } as NotificationModel));
        }
        else {
            dispatch(addOrUpdateTopSchemas(result.data.data));
            dispatch(setCountOfSchemas(result.data.count));
        }
        dispatch(setIsLoadingTopSchemas(false));
    }, [dispatch, searchValue, schemas?.length])

    const onLoadWithCleaning = React.useCallback(async () => {
        dispatch(addOrUpdateTopSchemas([]));
        dispatch(setCountOfSchemas(0));
        dispatch(setIsLoadingTopSchemas(true));
        const result = await SchemaProviderInstance.getAll(0, baseCount, searchValue);
        if (result.status !== 200) {
            dispatch(onThrowAlert({
                message: result.data.toString(),
                lifeTime: 10000
            } as NotificationModel));
        }
        else {
            dispatch(addOrUpdateTopSchemas(result.data.data));
            dispatch(setCountOfSchemas(result.data.count));
        }
        dispatch(setIsLoadingTopSchemas(false));
    }, [dispatch, searchValue])


    return {
        onLoadSchemas,
        onLoadWithCleaning
    }
}